import { useQuery } from "@tanstack/react-query";
import type { PaginationResponseType } from "@/features/shared/hooks/hooks/pagination.type";
import type { AccountResponse, AccountType } from "../types";
import { getAccounts } from "../services/get-accounts.service";

const KEY = ["cashPooling", "accounts"] as const;

interface UseAccountsParams {
  type: AccountType;
  fiscalNumber?: string;
  page?: number;
  size?: number;
}

/**
 * Hook to fetch accounts for cash pooling
 * @param params Request parameters including type filter (ORIGIN/DESTINATION)
 */
export const useAccounts = (params: UseAccountsParams) => {
  return useQuery<PaginationResponseType<AccountResponse>>({
    queryKey: [...KEY, params],
    queryFn: () => getAccounts(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
